import { Box, type BoxProps, type MantineNumberSize, Text } from '@mantine/core'
import { type FC, isValidElement, type ReactNode } from 'react'

export interface PropertyListItemProps extends Omit<BoxProps, 'children'> {
  label: string
  size?: MantineNumberSize
  value: ReactNode
}

export const PropertyListItem: FC<PropertyListItemProps> = ({ label, size = 'sm', value, ...props }) => (
  // `display: contents` removes this wrapper from layout so the label and value below become direct
  // grid items of the parent PropertyList. That is what lets every row share one label column sized to
  // the widest label — a per-row flex Group cannot do it, because flex has no cross-row sizing and so
  // the column width has to be guessed as a percentage.
  <Box
    sx={{ display: 'contents' }}
    {...props}
  >
    <Text
      align='right'
      size={size}
      sx={{ whiteSpace: 'nowrap' }}
      weight='bold'
    >
      {label}:
    </Text>
    {isValidElement(value) ? value : <Text size={size}>{value || '-'}</Text>}
  </Box>
)
